import { ChangeEvent, useContext, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { CreateTagPayload } from "../../api/types/tag";
import { useMutation } from "react-query";
import { createTagRequest } from "../../api/queries/tag/create";
import { appToastContext } from "../../context/toast";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

export default function TagForm() {
  const navigate = useNavigate();
  const [name, setName] = useState<string>("");
  const { ref: appToastRef } = useContext(appToastContext);

  const onNameChange = (event: ChangeEvent<HTMLInputElement>): void =>
    setName(event.target.value);

  const createTagMutation = useMutation({
    mutationFn: (payload: CreateTagPayload) => createTagRequest(payload),
    onSuccess: () => {
      if (appToastRef?.current) {
        appToastRef.current.show({
          severity: "success",
          summary: "Tag created successfully.",
        });
      }
    },
    onError: (error: any) => {
      if (appToastRef?.current) {
        appToastRef.current.show({
          severity: "success",
          summary: "Creating new tag failed " + error.message,
        });
      }
    },
  });
  const handleSubmit = async (event: any): Promise<void> => {
    event.preventDefault();
    const payload: CreateTagPayload = {
      name,
    };
    await createTagMutation.mutateAsync({
      ...payload,
    });
    navigate("/admin/tags");
  };

  const onCancel = () => navigate("/admin/tags");

  return (
    <form onSubmit={handleSubmit} className="col-12">
      <Panel header="Tag" toggleable={true} className="mb-3">
        <div className="p-fluid">
          <div className="grid formgrid pt-3">
            <div className="field col">
              <div className="p-float-label">
                <InputText value={name} onChange={onNameChange} />
                <label>Name *</label>
              </div>
            </div>
          </div>
        </div>
      </Panel>
      <div className="flex gap-1 justify-content-end">
        <Button
          type="button"
          label="Cancel"
          className="p-button-sm p-button-secondary"
          text={true}
          onClick={onCancel}
        />

        <Button
          type="submit"
          label="Save"
          className="p-button-main p-button-sm"
          disabled={!name}
        />
      </div>
    </form>
  );
}
